import React, { useRef } from "react";
import {
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
  AiOutlineShareAlt,
} from "react-icons/ai";

import { Link } from "react-router-dom";
import { CiClock1 } from "react-icons/ci";
import { BiMessageDetail } from "react-icons/bi";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const NewsSlider = () => {

const arroww1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/2023-annual report.pdf";
const rfp = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RFP_Thumbnail.png";
const addendum = "https://izbassetsmain.blob.core.windows.net/izbwebassets/addendum-Thumbnail_2.png";
const job = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Thumb_Image.png";
const solarTender = "https://izbassetsmain.blob.core.windows.net/izbwebassets/27-11-Solar_Tender.png";

const izbNewsSlider1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public-1.jpg";  

const izbNewsSlider2 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Indo-Zambia-Bank-to-Fund-Prospective-Home-1.jpg";  

const izbNewsSlider3 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/INDO-ZAMBIA-BANK-AND-ZAMBIA-AIR-FORCE.jpg";

const izbNewsSlider4 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-agreement-frontclear.png";

const izbNewsSlider7 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/celebrating-zambia-s-diamond-jubilee-of-independence-1.jpg";

const izbNewsSlider6 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB@40-1.jpg";

const izbNewsSlider8 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-partners-with-action-new-mod-4.jpg";


const izbNewsSlider9 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/zambia-financial-literacy-week-2025.png";

const izbNewsSlider10 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-40th-annual-general-meeting-5.png";

const izbNewsSlider11 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-3.jpg";

const izbNewsSlider12 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz-4.jpeg"

const izbNewsSlider13 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024-banner-1.png"
 

const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";
const career = "https://izbassetsmain.blob.core.windows.net/izbwebassets/EMPLOYMENT AND CAREER DEVELOPMENT OPPORTUNITIES-Thumbnail.png";
const customerNotice ="https://izbassetsmain.blob.core.windows.net/izbwebassets/Thumbnail-Customer Notice.png";
const customerNotice1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Customer_Notice_1-thumbnail.png";
function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowLeft}
      className={className}
      style={{
        ...style,
        display: "block",
        width: "50px",
        height: "50px",
        left: "-58px",
        zIndex:"99"
      }}
      onClick={onClick}
    />
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowRight}
      className={className}
 
      onClick={onClick}
    />
  );
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}; 

  return (
    <section className="news-slider-main">
      <div className="container">
        <div className="row">
          <div className="container">
            <div className="heading pt-5">
              <h1 className="text-center">Latest News</h1>
              <p className="text-center pt-2">All News And Updates</p>
            </div>
            <div
              className="py-4 read-more-flot-btn"
            >
              <Link
                to="/LatestNews"
                className="text-white rounded px-3 pt-1 pb-2"
                style={{ backgroundColor: "#9E1B1E" }}
              >
                View All <AiOutlineArrowRight size={21} className="me-1 pb-1" />
              </Link>
            </div>
          </div>


          <div className="col-xl-4 col-lg-4 hide-on-tablet">
                            <div
                              className="single-blog-style1 wow fadeInUp"
                              data-wow-delay="00ms"
                              data-wow-duration="1500ms"
                            >
                            <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024">
                              <div className="img-holder">
                                <div className="inner">
                                  <img className="imgresize" src={izbNewsSlider13} alt="" />
                            
                                    <div className="overlay-icon"></div>
                                
                                </div>
                              </div>
                              </a>
                                <div className="text-holder">
                                <h3 className="blog-title mt-0 text-left">
                                    <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024" style={{textTransform: "none"}}>
                                      Indo Zambia Bank is proud to be awarded Best Customer...
                                    </a><br/>
                                    <span style={{ fontSize: "15px", color: "gray" }}>May 13, 2025</span>
                                </h3>
                                <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                                  This past Friday, we were honoured to attend the 28th Annual Zambia Institute of Marketing Excellence Conference and Awards Gala Dinner held in Livingstone.
                                </p>
                                <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024">
                                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                                    </h5>
                                </a>
                                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                                </div>
                            </div>
          </div>

          <div className="col-xl-4 col-lg-4 hide-on-tablet">
                            <div
                              className="single-blog-style1 wow fadeInUp"
                              data-wow-delay="00ms"
                              data-wow-duration="1500ms"
                            >
                            <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz">
                              <div className="img-holder">
                                <div className="inner">
                                  <img className="imgresize" src={izbNewsSlider12} alt="" />
                            
                                    <div className="overlay-icon"></div>
                                
                                </div>
                              </div>
                              </a>
                                <div className="text-holder">
                                <h3 className="blog-title mt-0 text-left">
                                    <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz" style={{textTransform: "none"}}>
                                      Indo Zambia Bank Signs a (MoU) with the (DAZ)
                                    </a><br/>
                                    <span style={{ fontSize: "15px", color: "gray" }}>April 23, 2025</span>
                                </h3>
                                <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                                  Indo Zambia Bank is pleased to announce the signing of a Memorandum of Understanding (MoU) with the Dairy Association of Zambia (DAZ) for the provision of loan facilities to its members. Through this....
                                </p>
                                <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz">
                                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                                    </h5>
                                </a>
                                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                                </div>
                            </div>
          </div>

          <div className="col-xl-4 col-lg-4 hide-on-tablet">
                            <div
                              className="single-blog-style1 wow fadeInUp"
                              data-wow-delay="00ms"
                              data-wow-duration="1500ms"
                            >
                            <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                              <div className="img-holder">
                                <div className="inner">
                                  <img className="imgresize" src={izbNewsSlider11} alt="" />
                            
                                    <div className="overlay-icon"></div>
                                
                                </div>
                              </div>
                              </a>
                                <div className="text-holder">
                                <h3 className="blog-title mt-0 text-left">
                                    <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                                      Coffee & Cars with Indo Zambia Bank, in partnership...
                                    </a><br/>
                                    <span style={{ fontSize: "15px", color: "gray" }}>April 14, 2025</span>
                                </h3>
                                <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>This past weekend we partnered with Southern Cross Motors for an unforgettable Coffee & Cars experience! Guests had the unique opportunity to test drive some of the world’s finest motor vehicle brands...</p>
                                <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                                    Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                                    </h5>
                                </a>
                                <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                                </div>
                            </div>
          </div>


          <div className="test show-on-tablet news-slider-list-slider row align-items-center">
                <Slider {...settings}>

                  <div className="">
                                    <div
                                      className="single-blog-style1 wow fadeInUp"
                                      data-wow-delay="00ms"
                                      data-wow-duration="1500ms"
                                    >
                                     <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024">
                                      <div className="img-holder">
                                        <div className="inner">
                                          <img className="imgresize" src={izbNewsSlider13} alt="" />
                                    
                                            <div className="overlay-icon"></div>
                                        
                                        </div>
                                      </div>
                                      </a>
                                        <div className="text-holder">
                                        <h3 className="blog-title mt-0 text-left">
                                        <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024">
                                            Indo Zambia Bank is proud to be awarded Best Customer...
                                        </a><br/>
                                            <span style={{ fontSize: "15px", color: "gray" }}>May 13, 2025</span>
                                        </h3>
                                        <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                                            This past Friday, we were honoured to attend the 28th Annual Zambia Institute of Marketing Excellence Conference and Awards Gala Dinner held in Livingstone.
                                        </p>
                                        <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024">
                                            <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                                            Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                                            </h5>
                                        </a>
                                        <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                                        </div>
                                    </div>
                  </div>

                  <div className="">
                                    <div
                                      className="single-blog-style1 wow fadeInUp"
                                      data-wow-delay="00ms"
                                      data-wow-duration="1500ms"
                                    >
                                     <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz">
                                      <div className="img-holder">
                                        <div className="inner">
                                          <img className="imgresize" src={izbNewsSlider12} alt="" />
                                    
                                            <div className="overlay-icon"></div>
                                        
                                        </div>
                                      </div>
                                      </a>
                                        <div className="text-holder">
                                        <h3 className="blog-title mt-0 text-left">
                                        <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz">
                                            Indo Zambia Bank Signs a (MoU) with the (DAZ)
                                        </a><br/>
                                            <span style={{ fontSize: "15px", color: "gray" }}>April 23, 2025</span>
                                        </h3>
                                        <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                                            Indo Zambia Bank is pleased to announce the signing of a Memorandum of Understanding (MoU) with the Dairy Association of Zambia (DAZ) for the provision of loan facilities to its members. Through this....
                                        </p>
                                        <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz">
                                            <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                                            Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                                            </h5>
                                        </a>
                                        <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                                        </div>
                                    </div>
                  </div>

                  <div className="">
                                    <div
                                      className="single-blog-style1 wow fadeInUp"
                                      data-wow-delay="00ms"
                                      data-wow-duration="1500ms"
                                    >
                                     <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                                      <div className="img-holder">
                                        <div className="inner">
                                          <img className="imgresize" src={izbNewsSlider11} alt="" />
                                    
                                            <div className="overlay-icon"></div>
                                        
                                        </div>
                                      </div>
                                      </a>
                                        <div className="text-holder">
                                        <h3 className="blog-title mt-0 text-left">
                                        <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                                          Coffee & Cars with Indo Zambia Bank, in partnership...
                                        </a><br/>
                                            <span style={{ fontSize: "15px", color: "gray" }}>April 14, 2025</span>
                                        </h3>
                                        <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                                            This past weekend we partnered with Southern Cross Motors for an unforgettable Coffee & Cars experience! Guests had the unique opportunity to test drive some of the world’s finest motor vehicle brands...
                                        </p>
                                        <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                                            <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                                            Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                                            </h5>
                                        </a>
                                        <hr style={{ color: "#9E1B1E", margin: "0rem 0" }}/>
                                        </div>
                                    </div>
                  </div>
                        
                </Slider>
          </div>

          
        </div>
      </div>
    </section>
  );
};

export default NewsSlider;